import { Injectable } from '@angular/core';
import { NavController, Platform } from '@ionic/angular';
import { PlatformLocation } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
//  import { GaoDeLocation, PositionOptions } from '@ionic-native/gao-de-location/ngx';
import { Buffer } from 'buffer';
import { SysAccount } from '../../model/sys.account';
import { SysToken as Token } from '../../model/sys.token';
import { SysMenus as AppMenus, SysMenus } from '../../model/sys.menus';
import { BaseModal } from '../../model/base';
import { MessageclientService } from "../messageclient.service";
import { AppPageConfig, Data } from '../../model/xmlconfig/app.page.config';
import { AppPageElement as AppPageTemplateElement } from '../../model/xmlconfig/app.page.element';
import { AppPageTemplateConotent } from '../../model/xmlconfig/app.page.template.content';
import { AppSelectItems } from '../../model/xmlconfig/app.select.items';
import { Device } from '@ionic-native/device/ngx';
import { File } from '@ionic-native/file/ngx';
import { IndexService as NativeService } from "../native/index.service";
declare var app;
declare var AMap;//地图
declare var QRCode;//生成二维码
declare var IosSelect;//下拉控件
declare var cordova: any;
declare var wx: any;//启用微信客户端
@Injectable({
  providedIn: 'root'
})
export class IndexService {
  /**
   * 硬件，h5，微信公用使用的方法定义
   */
  constructor(
    private platform: Platform,
    //  private gd: GaoDeLocation,
    private router: Router,
    private base: BaseModal,
    private msg: MessageclientService,
    private navctr: NavController,
    private platformlocation: PlatformLocation,
    private device: Device,
    private file: File,
    private nativeService: NativeService,

  ) {
  }
  map: any;//地图对象
  geolocation: any;//定位对象
  circle: any;//范围配置
  /**
   * 小于10的数字前面加0
   * @param num 
   */
  public numberAddZore(num: Number): string {
    return num < 10 ? '0' + num : '' + num;
  }

  public getSysLocation(element: any): Promise<any> {
      return this.getH5CurrentPosition(element);

    // if (this.isAndroid) {
    //   return this.getGDCurrentPosition(element);
    // } else {
    //   return this.getH5CurrentPosition(element);
    // }
  }

  /**
   * 获取当前位置-H5和微信
   * @param element 绑定的html对象
   * @returns {address:"",latitude:"",longitude:"" } 处理后的返回值
   */
  public getH5CurrentPosition(element: any): Promise<any> {
    const that = this;
    return new Promise<any>((resolve, reject) => {
      try {
        that.map = new AMap.Map(element, {
          resizeEnable: true,
          zoom: 11
        });
        AMap.plugin('AMap.Geolocation', function () {
          that.geolocation = new AMap.Geolocation({
            enableHighAccuracy: true,//是否使用高精度定位，默认:true
            timeout: 10000,          //超过10秒后停止定位，默认：无穷大
            maximumAge: 0,           //定位结果缓存0毫秒，默认：0
            convert: true,           //自动偏移坐标，偏移后的坐标为高德坐标，默认：true
            showButton: true,        //显示定位按钮，默认：true
            buttonPosition: 'RB',    //定位按钮停靠位置，默认：'LB'，左下角
            buttonOffset: new AMap.Pixel(10, 20),//定位按钮与设置的停靠位置的偏移量，默认：Pixel(10, 20)
            showMarker: true,        //定位成功后在定位到的位置显示点标记，默认：true
            showCircle: true,        //定位成功后用圆圈表示定位精度范围，默认：true
            panToLocation: false,     //定位成功后将定位到的位置作为地图中心点，默认：true
            zoomToAccuracy: false      //定位成功后调整地图视野范围使定位位置及精度范围视野内可见，默认：false
          });
          that.map.addControl(that.geolocation);
          that.geolocation.getCurrentPosition();
          AMap.event.addListener(that.geolocation, 'complete', (status, result) => {
            if (status.accuracy == 440) {
              reject(status);
            } else {
              status["map"] = that.map;
              // let _op: LoationsOption = new LoationsOption();
              // let _op:GaoDeLocation=new GaoDeLocation();
               
              // _op.address = that.GetChineselanage(status.formattedAddress);
              // _op.latitude = status.position.lat;
              // _op.longitude = status.position.lng;
              let _op:any={};
              _op["address"] = that.GetChineselanage(status.formattedAddress);
              _op["latitude"]= status.position.lat;
              _op["longitude"] = status.position.lng;
              resolve(_op);
            }
          });
          AMap.event.addListener(that.geolocation, 'error', (status, result) => {
            reject(status);
          });
        });
      } catch (error) {
        reject(error);
      }
    });
  }
  /**
   * 获取当前位置-android和ios
   * @param element 绑定的html对象
   */
  // public getGDCurrentPosition(element: any): Promise<any> {
  //   const that = this;
  //   return new Promise<PositionOptions>((resolve, reject) => {
  //     let empty_PositionOptions:PositionOptions;
  //     that.gd.getCurrentPosition(empty_PositionOptions).then((pt: PositionOptions) => {
  //       console.log(pt, "定位成功");
  //       if (pt["status"] == "定位成功") {
  //         resolve(pt);
  //       } else {
  //         reject(pt);
  //       }
  //     }).catch(err => {
  //       console.log(err, "定位失败");
  //       reject(err);
  //     });
  //   });
  // }

  /**
 * 高德地图签到功能
 * @param element dom对象
 */
  public getMaplocation(element: any): Promise<any> {
    const that = this;
    return new Promise<any>((reject, reason) => {
      that.getH5CurrentPosition(element).then((data) => {
        // console.log(data);
        if (data.accuracy == 440) {
          reason(data);
        } else {
          let dataMessage = that.onComplete(data);
          reject(dataMessage);
        }
      }, (error) => {
        reason(error);
      });
    });
  }

  onComplete(data) {
    const that = this;
    if (app.CIRCLE) {//启用范围
      that.circle = that.dracircle(data.position.lng, data.position.lat);
      that.map.add(that.circle);
    }
    that.map.setFitView();
    return data;
  }
  //解析定位错误信息
  onError(data) {
    alert(data.message);
    return data.message;
  }
  /**
 * 范围配置
 * @param lng 横坐标
 * @param lat 纵坐标
 */
  dracircle(lng: string = '116.405467', lat: string = '39.907761') {
    let lnglatXY = new AMap.LngLat(lng, lat);
    return new AMap.Circle({
      center: lnglatXY, // 圆心位置
      radius: app.RADIUS,  //半径
      strokeColor: "#FFFFFF",  //线颜色
      strokeOpacity: 1,  //线透明度
      strokeWeight: 0,  //线粗细度
      fillColor: "#63B8FF",  //填充颜色
      fillOpacity: 0.35 //填充透明度
    });
  }
  /**
   * 描点标注
   * @param position 坐标
   */
  drawMarker(lng: any = '116.405467', lat: any = '39.907761', message: string = null) {
    let lnglatXY = new AMap.LngLat(lng, lat);
    return new AMap.Marker({
      position: lnglatXY,
      icon: new AMap.Icon({
        // size: new AMap.Size( 30, 30 ),  //图标大小
        image: "../../../assets/img/mark_b.png",
        // imageSize: new AMap.Size( 30, 30 )
      }),
      label: {
        offset: new AMap.Pixel(-1, -20),
        content: "<div class='info'>" + message + "</div>"
      }
    });
  }

  /**
 * 步行导航路线
 * @param element dom对象
 * @param endCoordinate 到达坐标系
 */
  WalkingOptionLine(element: any, endCoordinate: any,): Promise<any> {
    const that = this;
    return new Promise<any>((reject, reason) => {
      that.getH5CurrentPosition(element).then((data) => {
        // console.log(data);
        that.map = new AMap.Map(element, {
          zoom: 14,
          resizeEnable: true
        });
        let walking = new AMap.Walking({});
        //根据起终点坐标规划步行路线
        walking.search([data.position.lng, data.position.lat], [121.484145, 31.245521], function (status, result) {
          // result即是对应的步行路线数据信息，相关数据结构文档请参考  https://lbs.amap.com/api/javascript-api/reference/route-search#m_WalkingResult
          if (status === 'complete') {
            if (result.routes && result.routes.length) {
              that.drawRoute(result.routes[0], that.map);
              console.log('绘制步行路线完成')
            }
          } else {
            console.log('步行路线数据查询失败' + result)
          }
        });
        reject(data);
      }, (error) => {
        reason(error.message);
      });
    });
  }
  //展示图标以及文字
  drawRoute(route, map) {
    const that = this;
    let path = that.parseRouteToPath(route);
    let startMarker = new AMap.Marker({
      position: path[0],
      icon: 'https://webapi.amap.com/theme/v1.3/markers/n/start.png',
      map: map,
      label: {
        offset: new AMap.Pixel(-1, -20),
        content: "上海科技京城"
      }
    });
    let endMarker = new AMap.Marker({
      position: path[path.length - 1],
      icon: 'https://webapi.amap.com/theme/v1.3/markers/n/end.png',
      map: map,
      label: {
        offset: new AMap.Pixel(-1, -20),
        content: "门店1101"
      }
    })

    let routeLine = new AMap.Polyline({
      path: path,
      isOutline: true,
      outlineColor: '#ffeeee',
      borderWeight: 2,
      strokeWeight: 5,
      strokeColor: '#0091ff',
      lineJoin: 'round'
    })

    routeLine.setMap(map);

    // 调整视野达到最佳显示区域
    map.setFitView([startMarker, endMarker, routeLine]);
  }
  // 解析WalkRoute对象，构造成AMap.Polyline的path参数需要的格式
  // WalkRoute对象的结构文档 https://lbs.amap.com/api/javascript-api/reference/route-search#m_WalkRoute
  parseRouteToPath(route) {
    var path = []

    for (var i = 0, l = route.steps.length; i < l; i++) {
      var step = route.steps[i]

      for (var j = 0, n = step.path.length; j < n; j++) {
        path.push(step.path[j])
      }
    }

    return path
  }

  /**
 * 封装时间段查询
 * @param startDate 开始日期
 * @param endDate 结束日期
 */
  public BetweenDate(startDate, endDate) {
    let obj = {
      "BeforeValue": startDate,
      "EndValue": endDate,
      "Type": "Between"
    };
    return obj;
  }

  /**
   * 需要模糊查询的值
   * @param value 需要模糊查询的值
   */
  public LikeSearch(value: any) {
    return {
      "Value": value,
      "LikeType": "Middle",
      "Type": "Like"
    }
  }

  /**
   * 打电话
   * @param phone 电话号
   */
  public GetCallPhone(phone: string): Promise<any> {
    return new Promise<string>((resolve, reject) => {
      document.location.href = 'tel:' + phone;
      resolve("成功");
    })
  }

  /**
   * 发短信
   * @param phone 电话号
   * @param msg 信息
   */
  public GetSendMsg(phone: string, msg: string) {
    const that = this;
    return new Promise<any>((resolve, reject) => {
      if (that.BrowserRedirect === "maxos") {
        document.location.href = 'sms:' + phone + '&body=' + msg;
      } else {
        document.location.href = 'sms:' + phone + '?body=' + msg;
      }
      resolve("成功");
    });
  }

  /**
 * 加密方法（base64位加密）
 *@param encodeStr 加密字符串
 */
  encodeBase64(encodeStr: string): string {
    return new Buffer(encodeStr).toString('base64');
  }
  /**
   * 解密方法（只能处理64为密文）
   * @param decodeStr 加密密文
   */
  decodeBase64(decodeStr: string): string {
    return new Buffer(decodeStr, 'base64').toString();
  }

  /**
   * 级联控件
   * @param onwData 
   * @param twoData 
   * @param dataLevel 
   */
  public Iosselect(onwData: Array<any>, twoData: Array<any>, dataLevel: any) {
    return new Promise<any>((resolve, reject) => {
      let oneLevelId = dataLevel[0];
      let twoLevelId = dataLevel[1];
      let iosSelect = new IosSelect(2,
        [onwData, twoData],
        {
          title: '地址选择',
          itemHeight: 35,
          relation: [1, 1, 0],
          oneLevelId: oneLevelId,
          twoLevelId: twoLevelId,
          showLoading: true,
          callback: function (selectOneObj, selectTwoObj) {
            let obj: Array<any> = [];
            obj.push(selectOneObj);
            obj.push(selectTwoObj);
            resolve(obj)
          },
          fallback: function () {
            let _errobj = {};
            _errobj["message"] = "取消";
            _errobj["type"] = "cancel"
            reject(_errobj);
          },
          maskCallback: function () {
            let _errobj = {};
            _errobj["type"] = "colse"
            _errobj["message"] = "关闭";
            reject(_errobj);
          }
        });
    });
  }

  /**
   * 弹出日期控件
   * @param config 日期控件参数
   */
  public IosselectDateTime(config: any = {}): Promise<any> {
    const that = this;
    let now = new Date();
    let values = now.getFullYear() + "-" + (now.getMonth() + 1) + "-" + now.getDate() + " " + now.getHours() + ":" + now.getMinutes() + ":" + now.getSeconds();
    config = Object.assign({ "format": "default", "value": values }, config);
    // console.log(config);
    let arrayData: any;
    let oneLevelId: any = "";//now.getFullYear();
    let twoLevelId: any = "";//now.getMonth() + 1;
    let threeLevelId: any = "";//now.getDate();
    let fourLevelId: any = "";// now.getHours();
    let fiveLevelId: any = "";// now.getMinutes();
    let sixLevelId: any = "";//now.getSeconds();
    let year = that.FormatYear;
    let month = that.FormatMonth;
    let hours = that.GetHourData;
    let minutes = that.GetMinuteData;
    let seconds = that.GetSecondsData;
    let countTime: number = 6;
    /**
  * 关联月份
  * @param year 
  * @param month 
  */
    let GetDateDay = function (year, month, callback) {
      if (/^(1|3|5|7|8|10|12)$/.test(month)) {
        callback(that.FormatDate(31));
      }
      else if (/^(4|6|9|11)$/.test(month)) {
        callback(that.FormatDate(30));
      }
      else if (/^2$/.test(month)) {
        if (year % 4 === 0 && year % 100 !== 0 || year % 400 === 0) {
          callback(that.FormatDate(29));
        }
        else {
          callback(that.FormatDate(28));
        }
      }
      else {
        throw new Error('month is illegal');
      }
    };
    arrayData = [year, month, GetDateDay, hours, minutes, seconds];
    if (config.value) {
      let datavalue = that.FormatDateData(config.format, config.value);
      if (datavalue.length > 0) {

        if (datavalue[0]) {
          oneLevelId = datavalue[0].toString();
        }
        if (datavalue[1]) {
          twoLevelId = datavalue[1].toString();
        }
        if (datavalue[2]) {
          threeLevelId = datavalue[2].toString();
        }
        if (datavalue[3]) {
          fourLevelId = datavalue[3].toString();
        }
        if (datavalue[4]) {
          fiveLevelId = datavalue[4].toString();
        }
        if (datavalue[5]) {
          sixLevelId = datavalue[5].toString();
        }
      }
    } else {
      switch (config.format) {
        case "yyyymmdd"://年月日
          oneLevelId = now.getFullYear();
          twoLevelId = now.getMonth() + 1;
          threeLevelId = now.getDate();
          break;
        case "yyyymm"://年月
          oneLevelId = now.getFullYear();
          twoLevelId = now.getMonth() + 1;
          break;
        case "hhmmss"://时分秒
          fourLevelId = now.getHours();
          fiveLevelId = now.getMinutes();
          sixLevelId = now.getSeconds();
          break;
        case "hhmm"://时分
          fourLevelId = now.getHours();
          fiveLevelId = now.getMinutes();
          break;
        case "default":
        case "yyyymmddhhmmss":
          oneLevelId = now.getFullYear();
          twoLevelId = now.getMonth() + 1;
          threeLevelId = now.getDate();
          fourLevelId = now.getHours();
          fiveLevelId = now.getMinutes();
          sixLevelId = now.getSeconds();
          break;

      }
    }
    switch (config.format) {
      case "yyyymmdd"://年月日
        countTime = 3;
        arrayData = [year, month, GetDateDay];
        break;
      case "yyyymm"://年月
        countTime = 2;
        arrayData = [year, month];
        break;
      case "hhmmss"://时分秒
        countTime = 3;
        arrayData = [hours, minutes, seconds];
        break;
      case "hhmm"://时分
        countTime = 2;
        arrayData = [hours, minutes];
        break;

    }

    return new Promise<any>((resolve, reject) => {
      new IosSelect(countTime, arrayData, {
        title: '日期选择',
        itemHeight: 35,
        itemShowCount: 9,
        oneLevelId: oneLevelId,
        twoLevelId: twoLevelId,
        threeLevelId: threeLevelId,
        fourLevelId: fourLevelId,
        fiveLevelId: fiveLevelId,
        sixLevelId: sixLevelId,
        callback: function (selectOneObj, selectTwoObj, selectThreeObj, selectFourObj, selectFiveObj, selectSixObj) {
          let obj = {};
          // obj["year"]=selectOneObj;
          // obj["month"]=selectTwoObj;
          // obj["day"]=selectThreeObj;
          // obj["hours"]=selectFourObj;
          // obj["minutes"]=selectFiveObj;
          // obj["seconds"]=selectSixObj;
          // console.log(obj);
          switch (config.format) {
            case "yyyymmdd"://年月日
              obj["value"] = selectOneObj.id + "-" + selectTwoObj.id + "-" + selectThreeObj.id;
              obj["text"] = selectOneObj.value + selectTwoObj.value + selectThreeObj.value;
              break;
            case "yyyymm"://年月
              obj["value"] = selectOneObj.id + "-" + selectTwoObj.id;
              obj["text"] = selectOneObj.value + selectTwoObj.value;

              break;
            case "hhmmss"://时分秒
              obj["value"] = selectOneObj.id + ":" + selectTwoObj.id + ":" + selectThreeObj.id;
              obj["text"] = selectOneObj.value + selectTwoObj.value + selectThreeObj.id;
              break;
            case "hhmm"://时分
              obj["value"] = selectOneObj.id + ":" + selectTwoObj.id;
              obj["text"] = selectOneObj.value + selectTwoObj.value;
              break;
            case "default":
            case "yyyymmddhhmmss":
              obj["value"] = selectOneObj.id + "-" + selectTwoObj.id + "-" + selectThreeObj.id + " " + selectFourObj.id + ":" + selectFiveObj.id + ":" + selectSixObj.id;
              obj["text"] = selectOneObj.value + selectTwoObj.value + selectThreeObj.value + selectFourObj.value + selectFiveObj.value + selectSixObj.value;
              break;
          }
          resolve(obj);
        },
        fallback: function () {
          let _errobj = {};
          _errobj["message"] = "取消";
          _errobj["type"] = "cancel"
          reject(_errobj);
        },
        maskCallback: function () {
          let _errobj = {};
          _errobj["type"] = "colse"
          _errobj["message"] = "关闭";
          reject(_errobj);
        }
      });
    });
  }

  /**
 * 获取浏览器名称
 */
  get BrowserRedirect(): string {
    let mobileType = "";
    let sUserAgent = navigator.userAgent.toLowerCase();
    let bIsIpad = sUserAgent.match(/ipad/i);
    let bIsIphoneOs = sUserAgent.match(/iphone os/i);
    let bIsMidp = sUserAgent.match(/midp/i);
    let bIsUc7 = sUserAgent.match(/rv:1.2.3.4/i);
    let bIsUc = sUserAgent.match(/ucweb/i);
    let bIsAndroid = sUserAgent.match(/android/i);
    let bIsCE = sUserAgent.match(/windows ce/i);
    let bIsWM = sUserAgent.match(/windows mobile/i);
    let weixin = sUserAgent.match(/MicroMessenger/i);//微信
    if (bIsIpad || bIsIphoneOs) {
      mobileType = "maxos";
    } else if (weixin) {
      mobileType = "weixin";
    }
    else {
      mobileType = "pc";
    }
    return mobileType;
  }

  /**
   * 获取上传图片名称
   * 默认为当前时间戳
   */
  get GetImgFileName(): string {
    let date: Date = new Date();
    let year, month, day;
    let riqi = date.getFullYear().toString().substring(2, 4);
    let tmp1: any = date.getMonth() + 1;
    let tmp2: any = date.getDate();
    month = tmp1;
    day = tmp2;
    if (tmp1 < 10) {
      month = "0" + tmp1;
    }
    if (tmp2 < 10) {
      day = "0" + tmp2;
    }
    year = riqi;
    return year + month + day + date.getHours() + date.getMinutes() + date.getSeconds() + date.getMilliseconds();
  }

  /**
 * 获取当前存储的用户信息数据，如key为"account","menus","pageconfig","token";
 * @param obj 对应的key值
 */
  GetStorageKey(obj: string): any {
    let body: JSON = null;
    if (obj) {
      let Datakey = localStorage.getItem(obj);
      if (Datakey) {
        body = JSON.parse(Datakey);
      }
    }
    return body;
  }
  /**
 * 移除当前缓存数据
 * @param obj 对应的key值
 */
  RemoveStorageKey(obj: string): boolean {
    let istrue: boolean = false;
    if (obj) {
      if (this.GetStorageKey(obj)) {
        istrue = true;
        localStorage.removeItem(obj);
      }
    }
    return istrue;
  }
  /**
   * 清空当前缓存数据
   */
  removeAllStorage() {
    localStorage.clear();
  }
  /**
 * 在线生成二维码
 * @param element 当前的dom对象 
 * @param text 需要生成的文本信息
 */
  QRCodeinfo(element, text: string, width: number = 300, height: number = 300) {
    let qrcode = new QRCode(element, {
      width: width,
      height: height,
      colorDark: "#000000",
      colorLight: "#ffffff",
      src: "./assets/img/touxiang.jpg"
    });
    qrcode.makeCode(text);
  };

  /* *******************************************日期相关******************************************* */
  FormatDateData(type: any, data: string = "") {
    let timeDate: Array<any> = new Array<any>();
    let resultData: Array<any> = new Array<any>();
    if (data.indexOf("-") >= 0) {
      timeDate = data.split("-");
    } else if (data.indexOf("/") >= 0) {
      timeDate = data.split("/");
    } else if (data.indexOf(":") >= 0) {
      timeDate = data.split(":");
    }
    switch (type) {
      case "yyyymmdd"://年月日
        timeDate.forEach(item => {
          if (item.indexOf(":") >= 0) {
            if (item.split(" ")[0]) {
              resultData.push(Number.parseInt(item.split(" ")[0]));
            }
          } else {
            if (item) {
              resultData.push(Number.parseInt(item));
            }
          }
        });
        break;
      case "yyyymm"://年月
        timeDate.forEach(item => {
          if (item.indexOf(":").length < 0) {
            resultData.push(Number.parseInt(item));
          }
        });
        break;
      case "hhmmss"://时分秒
        timeDate.forEach(item => {
          if (item.indexOf(":") >= 0) {
            let temparray: any;
            if (item.split(" ").length > 0) {
              temparray = item.split(" ")[1];
              temparray.split(":").forEach(temp => {
                resultData.push(Number.parseInt(temp));
              });
            }
          } else {
            resultData.push(Number.parseInt(item));
          }
        });
        break;
      case "hhmm"://时分
        ////console.log(timeDate);
        timeDate.forEach(item => {
          if (item.indexOf(":") >= 0) {
            let temparray: any;
            if (item.split(" ").length > 0) {
              temparray = item.split(" ")[1];
              let hhtemp = temparray.split(":");
              for (let i = 0; i < hhtemp.length - 1; i++) {
                resultData.push(Number.parseInt(hhtemp[i]));
              }
            }
          } else {
            resultData.push(Number.parseInt(item));
          }
        });
        break;
      case "default"://时分
      case "yyyymmddhhmmss"://时分
        timeDate.forEach(item => {
          if (item.indexOf(":") >= 0) {
            let temparray: any;
            if (item.split(" ").length > 0) {
              resultData.push(item.split(" ")[0]);
              temparray = item.split(" ")[1];
              temparray.split(":").forEach(temp => {
                resultData.push(Number.parseInt(temp));
              });
            }
          } else {
            resultData.push(Number.parseInt(item));
          }
        });
        break;
    }
    return resultData;
  }
  /**
   * 格式化天数
   * @param count 
   */
  FormatDate(count) {
    var arr = [];
    for (var i = 1; i <= count; i++) {
      arr.push({
        id: i + '',
        value: i + '日'
      });
    }
    return arr;
  }
  /**
     * 格式化年份
     * @param nowYear 
     */
  get FormatYear() {
    let now = new Date();
    let nowYear = now.getFullYear();
    var arr = [];
    for (var i = nowYear - 5; i <= nowYear + 10; i++) {
      arr.push({
        id: i + '',
        value: i + '年'
      });
    }
    return arr;
  }
  /**
   * 格式化月份
   */
  get FormatMonth() {
    var arr = [];
    for (var i = 1; i <= 12; i++) {
      arr.push({
        id: i + '',
        value: i + '月'
      });
    }
    return arr;
  }
  /**
   * 计算小时
   * @param one 
   * @param two 
   * @param three 
   */
  get GetHourData() {
    var hours = [];
    for (var i = 0, len = 24; i < len; i++) {
      hours.push({
        id: i,
        value: i + '时'
      });
    }
    return hours;
  }
  /**
   * @param one 
   * @param two 
   * @param three 
   * @param four 
   * 计算分
  */
  get GetMinuteData() {
    var minutes = [];
    for (var i = 0, len = 60; i < len; i++) {
      minutes.push({
        id: i,
        value: i + '分'
      });
    }
    return minutes;
  }
  /**
   * 计算秒
   */
  get GetSecondsData() {
    var seconds = [];
    for (var i = 0, len = 60; i < len; i++) {
      seconds.push({
        id: i,
        value: i + '秒'
      });
    }
    return seconds;
  }
  /**
 * 获取当前时间包含年月日
 * @return 2020-12-02 14:22:18
 */
  get getNowdate() {
    let date: Date = new Date();
    let year, month, day;
    let arrayday = date.toLocaleDateString().split("/");
    let riqi = date.getFullYear();
    let tmp1: any = date.getMonth() + 1;
    let tmp2: any = date.getDate();
    month = tmp1;
    day = tmp2;
    if (tmp1 < 10) {
      month = "0" + tmp1;
    }
    if (tmp2 < 10) {
      day = "0" + tmp2;
    }
    year = riqi;
    return year + "-" + month + "-" + day + " " + date.getHours() + ":" + date.getMinutes() + ":" + date.getSeconds();
  }
  /**
   * 获取当前时间不包时分秒
   * @returns 2020-12-02
   */
  get getNow() {
    let date: Date = new Date();
    // console.log(1001011);
    let year, month, day;
    let arrayday = date.toLocaleDateString().split("/");
    let riqi = date.getFullYear();
    let tmp1: any = date.getMonth() + 1;
    let tmp2: any = date.getDate();
    month = tmp1;
    day = tmp2;
    if (tmp1 < 10) {
      month = "0" + tmp1;
    }
    if (tmp2 < 10) {
      day = "0" + tmp2;
    }
    year = riqi;
    return year + "-" + month + "-" + day;
  }
  /**
   * 获取当前时间不包含时分秒并且小于10不会添加零
   * @returns 2020-9-2
   */
  get getNows() {
    let date: Date = new Date();
    // ////console.log(1001011);
    let year, month, day;
    let arrayday = date.toLocaleDateString().split("/");
    let riqi = date.getFullYear();
    let tmp1: any = date.getMonth() + 1;
    let tmp2: any = date.getDate();
    month = tmp1;
    day = tmp2;
    year = riqi;
    return year + "-" + month + "-" + day;
  }
  /**
 * 获取当前时间YYYYMMDD
 * @returns 20201202
 */
  get getYMDNow() {
    let date: Date = new Date();
    // console.log(1001011);
    let year, month, day;
    let arrayday = date.toLocaleDateString().split("/");
    let riqi = date.getFullYear();
    let tmp1: any = date.getMonth() + 1;
    let tmp2: any = date.getDate();
    month = tmp1;
    day = tmp2;
    if (tmp1 < 10) {
      month = "0" + tmp1;
    }
    if (tmp2 < 10) {
      day = "0" + tmp2;
    }
    year = riqi;
    return year + "" + month + "" + day;
  }
  /**
   * 获取当前时间,yyyymmddHHmmss
   * @returns 20201202143311
   */
  get getNowDatetime() {
    let date: Date = new Date();
    console.log(date, "年月日");
    let year, month, day;
    let arrayday = date.toLocaleDateString().split("/");
    let riqi = date.getFullYear();
    let tmp1: any = date.getMonth() + 1;
    let tmp2: any = date.getDate();
    month = tmp1;
    day = tmp2;
    if (tmp1 < 10) {
      month = "0" + tmp1;
    }
    if (tmp2 < 10) {
      day = "0" + tmp2;
    }
    year = riqi;
    let str: string = year.toString() + month.toString() + day.toString() + date.getHours().toString() + date.getMinutes().toString() + date.getSeconds().toString();
    console.log(str);
    return str;
  }
  /* *******************************************日期相关******************************************* */
  /**
   * 获取登录消息
   */
  get GetAccount(): SysAccount {
    let account: SysAccount = new SysAccount();
    if (this.GetStorageKey("account")) {
      account = this.GetStorageKey("account");
    }
    return account;
  }

  /**
* token超时
*/
  public loginTimeOut() {
    const that = this;
    localStorage.removeItem("tokentimeOut");
    let expiresIn: number = Number(that.getToken.ExpiresIn);//that.getToken.ExpiresIn;
    //console.log("token过期时间:"+expiresIn);
    let y: number = 0;
    let timeout = setInterval(function () {
      // console.log(y);
      if (!that.GetAccount.IsLogin) {
        clearInterval(timeout);
        localStorage.removeItem("tokentimeOut");
        y = 0;
      }
      if (y == expiresIn) {
        clearInterval(timeout);
        y = 0;
        localStorage.setItem("tokentimeOut", "true");
      }
      y++;
    }, 1000);
  }
  /**
 * 获取token值
 */
  get getToken(): Token {
    let apptoken: Token;
    let apptokeninfo = localStorage.getItem("token");
    if (apptokeninfo) {
      apptoken = JSON.parse(apptokeninfo);
    }
    return apptoken;
  }

  /**
   * 获取本地时间与服务器时间差
   */
  getOutnumber() {
    let token = this.getToken;
    if (token) {
      let encodetoken = new Buffer(token.AccessToken.split('.')[1], 'base64').toString();
      let tokenData = JSON.parse(encodetoken);
      let Nowtimestamp = Math.round(new Date().getTime() / 1000);//获取当前时间的时间戳
      let timedifference = tokenData.nbf - Nowtimestamp;//保证本地时间与服务器同步
      localStorage.setItem("exp", tokenData.exp);//过期时间戳
      localStorage.setItem("timediffer", timedifference.toString());//误差时间戳
    }
  }

  /**
   * 跳转外部链接
   * @param url 跳转地址
   * @param title 页面标题
   */
  goWebPage(url: string, title: string) {
    this.Go('/webpage', { url: url, name: title });
  }

  /**
   * 计算倒计时
   */
  GetTimeOut(): Promise<any> {
    let that = this;
    return new Promise<any>((resolve, reject) => {
      if (that.base.Minute <= 0) {
        reject(false);
      } else {//倒计时启动时
        let icountTime = setInterval(() => {
          let obj = {};
          obj["check"] = false;
          obj["inter"] = icountTime;
          if (!that.base.InterVal) {
            resolve(obj);
          } else {
            // console.log(that.base.Second);
            if (that.base.Second < 10) {
              //如果秒数少于10在前面加上0
              that.base.timeOut = that.base.Minute + ":0" + that.base.Second;
            } else {
              that.base.timeOut = that.base.Minute + ":" + that.base.Second;
            }
            that.base.Second--;
            if (that.base.Second < 0) {
              that.base.Minute--;
              if (that.base.Minute < 0) {//判断分钟是否为0
                obj["check"] = true;
                obj["inter"] = icountTime;
                resolve(obj);
              }
              //如果秒数少于0就变成59秒
              that.base.Second = 59;
            }
          }
        }, 1000);
      }
    });
  }

  /**
   * 获取当前存储的用户信息数据，如key为"account","menus","pageconfig","token";
   * @param obj 对应的key值
   */
  public GetSessionStorageKey(obj: string): any {
    let body: JSON = null;
    if (obj) {
      let Datakey = sessionStorage.getItem(obj);
      if (Datakey) {
        body = JSON.parse(Datakey);
      }
    }
    return body;
  }

  /**
   * 角色code返回
   */
  get GetRoleSFA() {
    const that = this;
    let Roname: string = null;
    if (that.GetAccount.Roles) {
      if (that.GetAccount.Roles.length > 0) {
        Roname = that.GetAccount.Roles[0].RoleName;
      }
      that.GetAccount.Roles.forEach(items => {
        if (items.Code) {
          if (items.Code.toLocaleLowerCase().toString() == "1001" || items.Code.toLocaleLowerCase().toString() == "1004" || items.Code.toLocaleLowerCase().toString() == "1003" || items.Code.toLocaleLowerCase().toString() == "1002") {
            Roname = items.RoleName;
          }
        }
      });
    }
    return Roname;
  }

  /**
   * 用户退出登录
   */
  public LoginOut() {
    let that = this;
    that.msg.Confirm("确定注销当前帐号吗？").then(data => {
      if (data) {
        that.removeItem(new Array<string>("token", "pginfo", "tbstore", "setMap", "pgindata", "pgondate", "startDate", "enddate", "clock", "clockOut", "backurl", "exp", "menus", "readCount", "timediffer", "badge_" + that.GetAccount.Id, "ISCLOSE", "INFO", "loginError", "INFOBAGE"));
        sessionStorage.clear();
        // console.log(data);
        let out: SysAccount = new SysAccount();
        that.base.account = out;
        that.base.subMenus = [];
        localStorage.setItem("account", JSON.stringify(out));
        that.href('/login');
        // that.router.navigate(['/login'],{replaceUrl:true});
      }
    })
  }

  /**
   * 移除本地缓存数据,根据对应的key删除
   * @param item localStorage对应的key值，可以传多个,["key1","key2"...]
   */
  removeItem(item: Array<string> = []) {
    item.forEach(its => {
      localStorage.removeItem(its);
    });
  }

  /**
   * token过期
   */
  public LoginOutToken() {
    let that = this;
    let out: SysAccount = new SysAccount();
    that.base.account = out;
    that.base.subMenus = [];
    localStorage.setItem("account", JSON.stringify(out));
    that.href('/login');
  }
  /**
   * 页面跳转连接
   * @param url 需要跳转的url
   * @param isRefresh 是否刷新页面，针对返回上一页时处理
   */
  public href(url: string, isRefresh: boolean = false) {
    //console.log(url);
    // let urlArray: Array<string> = new Array<string>();
    // urlArray.push(url);
    return this.Go(url);
    // return this.router.navigate(urlArray, { replaceUrl: isRefresh });
  }

  /**
   * 获取一级菜单
   * @param url 
   */
  public getFirstMenuUrl(url: string): boolean {
    let meunsUrl: boolean = false;
    //console.log("menus");
    //获取一级菜单的url地址
    this.GetMenus.forEach((menus) => {
      if (this.getUrlList(url, menus.Component)) {
        meunsUrl = true;
      }
    });
    return meunsUrl;
  }
  /**
   * 获取是否第一级菜单
   * @param url 获取当前的url地址
   * @param menuUrl 数据库返回的url地址
   */
  public getUrlList(url, menuUrl: string): boolean {
    let _urlsplit = url.split('/');
    let homeurl = false;
    _urlsplit.forEach((items, index) => {
      if (items.toLowerCase() == menuUrl.toLowerCase()) {
        homeurl = true;
      }
    });
    return homeurl;
  }

  /**
   * 过滤url地址
   * @param url 
   */
  public replaceMenusUrl(url: any) {
    let _url: any = undefined;
    if (url) {
      _url = url.replace('/tabs/', '');
    }
    return _url;
  }
  /**
   * 对比一级菜单url地址
   * @param url url地址
   */
  public getMenusUrl(url: string = ""): boolean {
    // //console.log(url);
    const that = this;
    let meunsUrl: boolean = false;
    if (url == "/login") {
      meunsUrl = true;
    } else {
      //获取一级菜单的url地址
      that.GetMenus.forEach((menus) => {
        if (menus.Url.trim().toLowerCase() === url.replace('/tabs/', '').trim().toLowerCase() && menus.IsHome && menus.IsMainMenu) {
          meunsUrl = true;
        }
      });
    }
    return meunsUrl;
  }
  /**
   * 登录时获取有二级菜单的数据数据
   */
  public get getHomeMenus(): Array<SysMenus> {
    let sb: Array<SysMenus> = new Array<SysMenus>();
    const that = this;
    that.GetMenus.forEach((menus) => {
      if (typeof (menus.menus) != "undefined" || !menus.IsHome) {
        sb.push(menus);
      }
    });
    return sb;
  }
  /**
   * 获取首页展示菜单,只能一个
   */
  public getHonmeUrl(): SysMenus {
    let sb: SysMenus = new SysMenus();
    const that = this;
    that.GetMenus.forEach((menus) => {
      if (menus.IsHome && menus.IsMainMenu) {
        sb = menus;
      }
    });
    return sb;
  }

  /**
   * 获取选中的一级菜单
   * @param url 
   */
  public getMenuAction(url: string): number {
    let meunsAct: number;
    //获取一级菜单的url地址
    this.GetMenus.forEach((menus, index) => {
      if (url.replace('/tabs/', '').trim().toLowerCase().indexOf(menus.Url.trim().toLowerCase()) >= 0) {
        meunsAct = index;
      }
    });
    return meunsAct;
  }

  /**
   * 获取菜单节点
   */
  get GetMenus(): Array<AppMenus> {
    let appMenus: Array<AppMenus> = new Array<AppMenus>();
    let Menus = this.GetStorageKey("menus");
    if (Menus) {
      appMenus = Menus;
    }
    return appMenus;
  }

  /**
   * 获取页面数据节点
   */
  GetAllPageConfig(key: string): Array<AppPageConfig> {
    let appwebPage: Array<AppPageConfig> = new Array<AppPageConfig>();
    let appweb: Array<any> = new Array<any>();
    if (sessionStorage.getItem(key)) {
      try {
        let _t = JSON.parse(sessionStorage.getItem(key)) || {};//获取当前页面的配置数据
        appweb.push(_t);
      } catch (err) {
        console.log(err, "获取当前页面节点失败");
      }
    } else {
      appweb = this.GetStorageKey("pageconfig")||[];
      try {
        if (appweb.find((item) => item.Key == key)) {
          let _mp: any = appweb.find((item) => item.Key == key);
          appweb.push(_mp);
          let _temp: any = { Key: null, Data: null };
          _temp["Key"] = _mp.Key;
          _temp["Data"] = _mp.Data;
          sessionStorage.setItem(_mp.Key, JSON.stringify(_temp));
        };
      } catch (err) {
        console.log(err, "不支持find方法");
      }
    }
    if (appweb) {
      appwebPage = appweb;
    }
    return appwebPage;
  }

  /**
   * 过滤掉页面模块/字段权限数据节点
   */
  private GetFieldPageConfig(key: string): Data {
    let appwebPage: Data = null;
    let appweb = this.GetStorageKey("pagemode");//模块权限过滤
    if (appweb) {
      let appfieldpersion = appweb[key];
      if (appfieldpersion) {
        let searchList = appfieldpersion;
        if (searchList) {
          appwebPage = searchList;
        }
      }
    }
    return appwebPage;
  }

  /**
   * 
   * @param data 存储临时数据
   */
  SetTempPageMode(data: any) {
    let pageconfigmodel = JSON.parse(localStorage.getItem("temppagemode"));
    if (pageconfigmodel) {
    } else {
      localStorage.setItem("temppagemode", JSON.stringify(data));
    }
  }

  /**
   * 获取临时
   * @param configName 获取当前xml名称
   */
  GetTempPageModeKey(configName: string) {
    let data = null;
    let pagemodel = JSON.parse(localStorage.getItem("temppagemode"));
    if (pagemodel) {
      data = pagemodel;
    }
    return data;
  }

  /**
   * PG信息数据
   */
  get getPGInfo() {
    let pginfo = this.GetStorageKey("pginfo");
    if (pginfo) {
      return pginfo;
    } else {
      return {};
    }
  }

  /**
   * 判断角标是否完成，返回bool类型；默认 true
   * @param pangeName 当前页面的pagename;
   */
  getBadge(pangeName: any) {
    const that = this;
    let isbadge: boolean = true;
    //先判断是否必填/或者设置上班可操作时有效
    let homeArray: Array<any> = that.GetStorageKey("badge_" + that.GetAccount.Id);
    ////console.log(homeArray);
    const PageName = pangeName;
    if (homeArray) {
      const newArraYList: any = homeArray.find(items => items.pageName.trim().toLowerCase() == PageName.trim().toLowerCase());
      if (newArraYList) {
        newArraYList.temps.forEach(temp => {
          temp.btns.forEach(btn => {
            if (btn.employLimit == "work") {
              if (btn.required && !btn.state) {
                isbadge = false;
              }
            } else {
              if (btn.required && !btn.state) {
                isbadge = false;
              }

            }
          });
        });
      }

    }
    return isbadge;
  }

  /**
   * 更改角标数据，完成/未完成及时更新
   * @param pageName 当前页面的pageName
   * @param btnName 更改的按钮Name
   */
  setBadge(pageName: any, templateName: any, btnName: any) {
    const that = this;
    //先判断是否必填项未完成
    //  //console.log(1101);
    let badgeArray: Array<any> = that.GetStorageKey("badge_" + that.GetAccount.Id);
    if (badgeArray) {
      const addArraYList: any = badgeArray.find(items => items.pageName.trim().toLowerCase() == pageName.trim().toLowerCase());
      if (addArraYList) {
        let addList: any = addArraYList.temps.find(titem => titem.tempName.trim().toLowerCase() == templateName.trim().toLowerCase());
        if (addList) {
          addList.btns.forEach(btn => {
            if (btn.btnName.trim().toLowerCase() == btnName.trim().toLowerCase()) {
              btn.state += 1;
            }
          });
        }
      }
    }
    localStorage.setItem("badge_" + that.GetAccount.Id, JSON.stringify(badgeArray));
    // console.log(badgeArray);
  }

  /**
   * 返回上一个页面
   * @param isRefresh 是否刷新上一个页面，默认刷新,default:true
   */
  goBack(isRefresh: boolean = true) {
    const that = this;
    console.log("backlouut.....");
    let arrayList: Array<any> = [];
    let urltemp: any = "";
    if (localStorage.getItem("backurl")) {
      arrayList = that.GetStorageKey("backurl") || [];// JSON.parse(localStorage.getItem("backurl"));
      if (arrayList.length > 0) {
        urltemp = arrayList[arrayList.length - 1];
        if (urltemp.indexOf('[Refresh]') >= 0) {//表示是不刷新页面则主动设置isRefresh为false
          isRefresh = false;
        }
        urltemp = urltemp.replace("[Refresh]", "");
        arrayList.splice(arrayList.length - 1, 1);
        localStorage.setItem("backurl", JSON.stringify(arrayList));
        if (isRefresh) {//如果刷新页面,添加时间戳
          if (urltemp.split('/').length == 4) {
            // if(that.getFirstMenuUrl(urltemp)){//如果configName则
            //   that.router.navigate([urltemp]);
            // }else{
            //   that.router.navigate([urltemp+'/'+that.getNowDatetime]);
            // }
            that.Go(urltemp + '/' + that.getNowDatetime);

          } else if (urltemp.split('/').length == 5) {
            that.Go(urltemp + '/' + that.getNowDatetime);
          } else {
            if (urltemp.indexOf('&') == "-1") {
              that.Go(urltemp + '&' + that.getNowDatetime);
            } else {
              that.Go(urltemp + that.getNowDatetime);
            }

          }
        } else {
          that.Go(urltemp);
        }

      } else {
        that.navctr.pop();
      }

    } else {
      that.navctr.pop();
    }

  }

  /**
   * 移除返回
   */
  removeBack() {
    let arrayback: Array<any> = [];
    if (localStorage.getItem("backurl")) {
      arrayback = this.GetStorageKey("backurl") || [];
      if (arrayback.length > 1) {//判断缓存几个url地址
        arrayback.splice(arrayback.length - 1, 1);
      }
      localStorage.setItem("backurl", JSON.stringify(arrayback));
    }
  }

  /**
   * 获取当前页面地址
   * @param isRefresh 存取地址时，判断是否返回时刷新当前页面,默认为"true"刷新
   */
  setHistoryUrl(isRefresh: boolean = true) {
    let that = this;
    let locationback: Array<any> = [];
    if (localStorage.getItem("backurl")) {
      locationback = that.GetStorageKey("backurl") || [];//    JSON.parse(localStorage.getItem("backurl"));
    }
    //console.log("地址对比");
    if (that.platformlocation["location"].hash.replace('#', '')) {
      const backurl: any = that.platformlocation["location"].hash.replace('#', '');
      const newurl: any = locationback[locationback.length - 1];
      let historyUrl = that.platformlocation["location"].hash.replace('#', '');
      if (!isRefresh) {//刷新时处理
        historyUrl = historyUrl + "[Refresh]";
      }
      if (newurl && backurl) {
        if (newurl.indexOf('&') != "-1" && backurl.indexOf('&') != "-1") {//表示有时间戳
          const _strurl = newurl.substring(0, newurl.lastIndexOf('/'));
          const _newurl = backurl.substring(0, backurl.lastIndexOf('/'));
          if (_strurl != _newurl) {
            locationback.push(historyUrl);
          }
        } else {
          locationback.push(historyUrl);
        }
      } else {
        locationback.push(historyUrl);
      }
    }
    localStorage.setItem("backurl", JSON.stringify(locationback));
  }

  /**
   * 坐标距离计算
   * @param lng  开始纵坐标
   * @param lat 开始横坐标
   * @param endlng 结束纵坐标
   * @param endlat 结束横坐标
   */
  Dist(lng, lat, endlng, endlat): any {
    if (lng > 0 && lat > 0 && endlng > 0 && endlat > 0) {
      let sqlnumber: number = 6378137 * 2 * Math.asin(
        Math.sqrt(
          Math.pow(Math.sin((lat - endlat) * Math.acos(-1) / 360), 2)
          + Math.cos(lat * Math.acos(-1) / 180)
          * Math.cos(endlat * Math.acos(-1) / 180)
          * Math.pow(Math.sin((lng - endlng) * Math.acos(-1) / 360), 2)
        )
      );
      if (sqlnumber < 0) {
        sqlnumber = 0;
      }
      return sqlnumber;
    }
    else {
      return 0;
    }
  }

  /**
   * 跳转二维码页面
   * @param data 二维码数据
   */
  goQrCode(data: string, type: string = "二维码", title: string = "二维码") {
    const param = encodeURIComponent(data);
    const _type = encodeURIComponent(type + "&" + title);
    this.Go('/tabs/qrcode/' + _type + "/" + param + "&" + this.getNowDatetime);
  }

  /**
   * 判断是否正整数
   * @param str 需要输入的值
   */
  isNumber(str: any) {
    const code = new RegExp("^[0-9]*$");
    const maxNum: number = Number.parseInt(app.NUM);
    // console.log(code.test(str));
    let codeNum: number = 0;
    if (code.test(str)) {
      codeNum = Number.parseInt(str);
      if (codeNum > maxNum) {
        return false;
      } else {
        return true;
      }
    } else {
      return false;
    }
  }

  /**
  * 验证是否正整数，并且返回数字，或者null
  * @param str 需要输入的值
  */
  GetNumber(str: any) {
    const code = new RegExp("^[0-9]*$");
    const maxNum: number = Number.parseInt(app.NUM);
    let codeNum: number = 0;
    // console.log(str);
    if (code.test(str)) {
      codeNum = Number.parseInt(str);
      let strnum = codeNum;
      if (codeNum > maxNum) {
        let maxlength: number = maxNum.toString().length;
        codeNum = Number.parseInt(strnum.toString().substring(0, maxlength));
      }
      return codeNum;
    } else {
      return null;
    }
  }

  /**
   * 判断小数点后两位小数
   * @param str  需要输入的值
   */
  isDouble(str: any) {
    const code = /^(([1-9][0-9])|(([0].\d{0,2}|[1-9][0-9].\d{0,2})))$/;
    // console.log(code.test(str));
    return code.test(str);
  }

  /**
  * 保存当前页面的查询条件
  * @param obj 页面保存的筛选条件
  */
  SaveSearchInfo(obj: any) {
    let _arr = this.GetStorageKey("searchArray") || [];
    let _isAdd = false;
    // _arr.forEach(item=>{
    //   if(item.pageName == obj.pageName){
    //     item = obj;
    //     _isAdd = true;
    //   }
    // })
    for (let i = 0; i < _arr.length; i++) {
      if (_arr[i].pageName == obj.pageName) {
        _arr[i] = obj;
        _isAdd = true;
      }
    }
    if (!_isAdd) {
      _arr.push(obj);
    }
    localStorage.setItem("searchArray", JSON.stringify(_arr));
  }

  /**
   * 盘库日期限制
   */
  InventoryDatelimit() {
    const day = new Date().getDate();
    let limitArr = app.Inventory.split(",");
    let isSubmit = false;
    limitArr.forEach(item => {
      if (day == item) {
        isSubmit = true;
      }
    })
    let _obj = {
      isSubmit: isSubmit,
      begin: limitArr[0] || 0,
      end: limitArr[limitArr.length - 1] || 0
    }
    return _obj;
  }
  /**
   * debug 输出模式
   * @param message 文本内容
   */
  Log(message: any) {
    if (app.DEBUG) {
      console.log(message);
    }
  }

  /**
   * 考试等级
   * @param code 
   */
  getGradeCode(code: string) {
    if (!code) {
      return 0;
    }
    switch (code) {
      case "D000":
        return 0;
      case "D001":
        return 1;
      case "D002":
        return 2;
      case "D003":
        return 3;
      default:
        return 0;
    }
  }

  /**
   * 计算localStorage剩余大小(kb)
   */
  getStorageSize() {
    var size = 0;
    for (let item in window.localStorage) {
      if (window.localStorage.hasOwnProperty(item)) {
        size += window.localStorage.getItem(item).length;
      }
    }
    return (size / 1024).toFixed(2) + 'KB';
  }

  /**
 * 获取缓存中需要的配置项
 */
  GetStaticObject() {
    let data: Array<any> = this.GetStorageKey("StaOb") || [];
    if (data) {
      data.forEach((e, index) => {
        if (e.a_Code) {
          if (e.a_Code == "WEBSITE") {//处理所有常量关联域名问题处理
            if (localStorage.getItem("WEBSITE")) {
              e.a_Value = localStorage.getItem("WEBSITE");
            }
            this.getWebSetApp("WEBSITE", e.a_Value);
          } else if (e.Code == "WEBURL") {
            this.getWebSetApp("WEBURL", e.a_Value);
          } else {
            app[e.a_Code] = e.a_Value;
          }
        }
      });
    }
  }
  /**
     * 测试切换时域名切换回来问题
     */
  getAppsetting() {
    const that = this;
    if (!that.GetStorageKey("StaOb")) {
      that.loadScript("assets/appsettings.js", function (load) { console.log(load) });
      return;
    } else {
      let arrayListNew: Array<any> = that.GetStorageKey("StaOb");
      arrayListNew.forEach((El, index) => {
        if (El.a_Code == "WEBSITE" && El.a_Value) {
          that.getWebSetApp("WEBSITE", El.a_Value);
          //   app.WEBSITE=El.a_Value;
        }
      });
    }
  }
  /**
   * 更具后端配置切换本地配置文件数据
   */
  getAppConfig(appArray: Array<any> = []) {
    appArray.forEach((e, index) => {
      if (e.a_Code) {
        if (e.a_Code == "WEBSITE") {//处理所有常量关联域名问题处理
          // _findSite.push(e);
          this.getWebSetApp("WEBSITE", e.a_Value);
        } else if (e.a_Code == "WEBURL") {
          // _findSite.push(e);
          this.getWebSetApp("WEBURL", e.a_Value);
        }
        else {
          // other.push(e);
          app[e.a_Code] = e.a_Value;
        }
      }
    });
  }
  /**
   * 修改域名多处使用地方处理
   * @param appName 当前域名的key
   * @param value 对应的value值
   */
  getWebSetApp(appName: string, value: string) {
    let app_value = app[appName];
    for (let key in app) {
      if (key == "WEBSITE" || key == "WEBURL") {

      } else {
        if (typeof (app[key]) == "string") {
          if (app[key]) {
            if (key != appName) {
              if (app[key].indexOf(app_value) != -1) {
                app[key] = app[key].replace(app_value, value);
              }
            }
          }
        }
      }
    }
    app[appName] = value;
  }

  /**
   * 动态加载js文件
   * @param src  文件路劲
   * @param callback 返回值
   */
  loadScript(src, callback) {
    let script = document.createElement('script'),
      head = document.getElementsByTagName('head')[0];
    script.type = 'text/javascript';
    script.charset = 'UTF-8';
    script.src = src;
    if (script.addEventListener) {
      script.addEventListener('load', function () {
        callback();
      }, false);
    }
    head.appendChild(script);
  }

  /**
* 去除特殊字符
* @param str 
*/
  GetChineselanage(str: string = "") {
    if (!str) {
      str = "";
    }
    let ar: Array<string> = app.Special.split(',');
    ar.forEach(chart => {
      str = str.replace(new RegExp(chart, 'g'), "");
    });
    return str;
  }

  /**
   * 文件类型 默认为:".pdf"
   * @param key 当前文件的后缀名称，默认:".pdf"
   */
  ContentType(key: string = ".pdf") {
    const that = this;
    let contentType: any = {
      ".mp4": "video/mp4",
      ".wmv": "video/x-ms-wmv",
      ".pdf": "application/pdf",
      ".xml": "application/xml",
      ".zip": "application/zip",
      ".ppt": "application/x-ppt"
    };
    console.log(".pdf", "文件类型");
    /**
     * 获取后端返回的配置文件
     */
    if (app["MIME"]) {
      contentType = Object.assign(contentType, app["MIME"]);
    }
    let defaultobj: any = that.GetStorageKey("StaOb");
    if (defaultobj) {
      if (defaultobj["MIME"]) {
        app["MIME"] = defaultobj["MIME"];
        contentType = Object.assign(contentType, defaultobj["MIME"]);
      }
    }
    let fileType: any = "application/pdf";
    fileType = contentType[key];
    return fileType;
  }

  /**
   * 隐藏手机号中间四位
   */
  hidePhoneNumber(value) {
    if (!value) { return value; }
    const reg = /^(\d{3})\d{4}(\d{4})$/;
    return value.toString().replace(reg, "$1****$2");
  }

  /**
   * 判断当前登录状态是否需要拉取数据
   */
  IsLoginInfo() {
    const that = this;
    let isresult: boolean = false;
    if (that.GetStorageKey("sysimie") && that.GetStorageKey("sysimie").imei == that.getYMDNow) {
      if (that.GetAccount.IsLogin && that.GetStorageKey("menus")) {
        //如果是pg,店主，门店必须存在
        if (that.GetAccount.Roles.find(r => r.Code == "1002")) {
          if (that.GetStorageKey("pginfo") && that.GetStorageKey("tbstore")) {
            isresult = true;
          } else if (that.GetAccount.Roles.find(r => r.Code == "1006")) {
            if (that.GetStorageKey("tbstore")) {
              isresult = true;
            }
          }
        } else {
          isresult = true;
        }
      }
    }
    return isresult;
  };
  /***
   * 获取当前登录的时间
   */
  SetLoginTimeToken() {
    const that = this;
    let b = { "imei": "" };
    b.imei = that.getYMDNow;
    localStorage.setItem("sysimie", JSON.stringify(b));
  }

  /**
 * 过滤当前页面，以及数据权限
 * @param allPageModel 系统xml
 * @param configName 当前页面名称
 */
  public PageModalOrPermission(allPageModel: Data, configName?: string): Data {
    const that = this;
    let fieldPage: Data = that.GetFieldPageConfig(configName);//获取当前页面配置数据
    if (fieldPage) {
      //判断首节菜单是否有权限
      let head = "";
      if (fieldPage.head) {
        head = fieldPage.head.name || "";
      }
      if (head != "") {
        delete allPageModel.head;
      } else {
        if (fieldPage.head) {
          if (fieldPage.head.element.length > 0) {
            fieldPage.head.element.forEach((element, index) => {
              let head_element = element || "";
              if (head_element != "") {
                allPageModel.head.element.splice(index, 1);
              }
            });
          }
        }
      }

      //判断内容块是否有权限
      if (fieldPage.template.length > 0) {//判断当前页面是否有模块template
        fieldPage.template.forEach((item, tindex) => {
          let j = allPageModel.template.length;
          while (j--) {
            if (allPageModel.template[j].name.trim().toLowerCase() === item.name.toString().toLowerCase()) {
              if (!item.head && !item.content) {
                allPageModel.template.splice(j, 1);
              }
              if (item.head) {
                if (item.head.name) {
                  delete allPageModel.template[j].head;
                } else {
                  if (item.head.element.length > 0) {//判断头部模块下的element是否有权限
                    item.head.element.forEach(heade => {
                      let hi = allPageModel.template[j].content.element.length;
                      while (hi--) {
                        if (allPageModel.template[j].head.element[hi].name.toString().trim().toLowerCase() == heade.toString().trim().toLowerCase()) {
                          allPageModel.template[j].head.element.splice(hi, 1);
                        }
                      }
                    });
                    // allPageModel.template[tindex].head.element=this.ElementFilter(item.head.element,tindex,allPageModel.template[tindex].head.element);
                  }
                }
              }
              if (item.content) {//content模块存在.如果 content Name属性存在，就判断无权限,直接删除,如果content节点存在,element节点也存在需要遍历删除
                if (item.content.name) {
                  delete allPageModel.template[tindex].content;
                } else {
                  if (item.content.element.length > 0) {
                    item.content.element.forEach(ele => {
                      let ci = allPageModel.template[j].content.element.length;
                      while (ci--) {
                        if (allPageModel.template[j].content.element[ci].name.toString().trim().toLowerCase() == ele.toString().trim().toLowerCase()) {
                          allPageModel.template[j].content.element.splice(ci, 1);
                        }
                      }
                    });
                    //  allPageModel.template[tindex].content.element=this.ElementFilter(item.content.element,tindex,allPageModel.template[tindex].content.element,item.content.configName);
                  }
                }
              }
            }
          }
        });
      }
    }
    //处理当前页面的字段权限过滤
    if (allPageModel.head) {
      allPageModel.head.element.forEach((tes, tindex) => {
        if (tes.selectItemList.gridViewConfigName) {
          allPageModel.head.element[tindex].selectItemList.selectItem = this.SelectItemsFilter(tes.selectItemList.selectItem, tes.selectItemList.gridViewConfigName);
        }
      });
    }
    if (allPageModel.template.length > 0) {
      allPageModel.template.forEach((temp, indexs) => {
        //头部节点
        if (temp.head) {
          if (temp.head.element.length > 0) {
            temp.head.element.forEach((hitem, hindex) => {
              if (hitem.selectItemList.gridViewConfigName) {
                allPageModel.template[indexs].head.element[hindex].selectItemList.selectItem = this.SelectItemsFilter(hitem.selectItemList.selectItem, hitem.selectItemList.gridViewConfigName);
              }
            });
          }
        }
        //内容块节点

        if (temp.content) {
          if (temp.content.element.length > 0) {
            if (temp.content.configName) {
              allPageModel.template[indexs].content = this.ContentPersionFilter(allPageModel.template[indexs].content, temp.content.configName.trim());
            }
            temp.content.element.forEach((eitem, eindex) => {
              if (eitem.selectItemList.gridViewConfigName) {
                allPageModel.template[indexs].content.element[eindex].selectItemList.selectItem = this.SelectItemsFilter(eitem.selectItemList.selectItem, eitem.selectItemList.gridViewConfigName);
              }
            });
          }
        }
      });
    }
    return allPageModel;
  }

  /**
   * 过滤页面中Element没有权限的节点；
   * @param _element 当前页面Element节点
   * @param index 当前节索引
   * @param All 本地数据对应的节点Element
   * @param configName 判断父级是否有ConfigName
   */
  public ElementFilter(_element: Array<AppPageTemplateElement>, index: number, AllEle: Array<AppPageTemplateElement>, configName: string = null): Array<AppPageTemplateElement> {
    //console.log(8008088);
    //先判断是否有权限菜单权限，过滤掉没有权限的Element
    _element.forEach((Nitem, Nindex) => {
      let c_E: any = Nitem || "";//节点没有权限时，处理本地缓存中对应的节点
      if (c_E.trim() != "") {
        let j = AllEle.length;
        while (j--) {
          if (AllEle[j].name.trim().toLowerCase() === c_E.toString().toLowerCase()) {
            AllEle.splice(j, 1);
          }
        }
      }
    });
    //如果Content节点上存在ConfigName时过滤字段权限
    if (configName && configName != "") {
      const filterE = this.GetStorageKey("fieldpermission") || {};//获取字段权限
      let k = AllEle.length;
      while (k--) {
        let itemkey = filterE[configName];
        if (itemkey) {
          const ekey = itemkey[configName][AllEle[k].field];
          if (typeof (ekey) != "undefined") {
            if (ekey === 0) {//表示不可见状态
              AllEle.splice(k, 1);
            } else if (ekey === 2) {//表示只读状态
              AllEle[k].readonly = true;
            }
          }

        }
      }
    }
    return AllEle;
  }
  /**
   * 过滤content存在ConfigName时的字段权限；
   * @param AllEle 获取对应的Content节点
   * @param configName 当前的xml名称
   */
  public ContentPersionFilter(AllEle: AppPageTemplateConotent, configName: string = null): AppPageTemplateConotent {
    const filterE = this.GetStorageKey("fieldpermission") || {};//获取字段权限
    let k = AllEle.element.length;
    while (k--) {
      let itemkey = filterE[configName];
      if (itemkey) {
        const ekey = itemkey[AllEle.element[k].name];
        if (typeof (ekey) != "undefined") {
          if (ekey === 0) {//表示不可见状态
            AllEle.element.splice(k, 1);
          } else if (ekey === 2) {//表示只读状态
            AllEle.element[k].readonly = true;
          }
        }
      }
    }
    return AllEle;
  }
  /**
   * element节点下selectItem节点字段权限
   * @param selectItem  当前xml selectItem节点
   * @param ConfigName  当前Element节点 ConfigName属性值
   */
  public SelectItemsFilter(selectItem: Array<AppSelectItems>, ConfigName: string) {
    const filterE = this.GetStorageKey("fieldpermission") || {};//获取字段权限
    //  let newArrayItem:Array<AppPageTemplateSelectItem>=new Array<AppPageTemplateSelectItem>();
    if (filterE[ConfigName]) {
      const len = selectItem.length - 1;
      for (let t = len; t >= 0; t--) {
        const pkey = filterE[ConfigName][selectItem[t].field];
        if (typeof (pkey) != "undefined") {
          if (pkey === 0) {
            selectItem.splice(t, 1);
          } else if (pkey === 2) {
            selectItem[t].readonly = true;
          }
        }
      }
    }
    return selectItem;

  }
  /**
   * 遍历菜单,把一次菜单但不是首页的放入其他一次菜单中
   * @param _menus 菜单对象
   */
  public GetMenusDataList(_menus: Array<any>) {
    let meus_False: Array<any> = new Array<any>();
    let arrayList: Array<any> = new Array<any>();
    _menus.forEach((items, index) => {
      if (items.IsHome === false) {
        meus_False.push(items);
      }
    });
    _menus.forEach((items, index) => {
      if (items.IsHome === true) {
        if (typeof (items.menus) != "undefined") {
          meus_False.forEach((its, index) => {
            items.menus.push(its);
          });
        }
        arrayList.push(items);
      }
    });
    return arrayList;
  }

  /**
   * 遍历数组数据获取当前页面权限数据对象以及整个框架结果数据
   * @param data 
   */
  public JurisdictionArrayList(data: any, xmlconfigName: string): Array<any> {
    console.log(data, "数据");
    let bw: Array<any> = new Array<any>();
    let juest: any = { "xml": null, "all": [] };
    data.forEach(el => {
      if (el["Key"] == xmlconfigName) {
        juest.xml = this.GetPageConfigData(el, xmlconfigName);
      }
    });
    juest.all = data;
    return juest;
  }

  /**
   * 获取对应的页面配置列表文件
   * @param page 表示当前页面配置。
   * @param key 表示当前页面configName。
   */
  public GetPageConfigData(page: any, Key: string): Data {
    //console.log(1001011);
    let allpageConfigweb: Data = null;
    if (page.Data) {
      allpageConfigweb = page.Data;
      allpageConfigweb = this.PageModalOrPermission(page.Data, Key);
    }
    return allpageConfigweb;
  }

  /**
   * 获取对应的页面配置列表文件
   * @param Key 表示当前页面的名称，类似于后端对应的xml的ConfigName值。
   * @param isfieldpersion:表示是否权限过滤的数据源，默认所有数据false
   */
  public GetPageConfigKey(Key: string, isfieldpersion: boolean = false): Data {
    //console.log(1001011);
    let allpageConfigweb: Data = null;
    let pageList: Array<AppPageConfig> = null;
    pageList = this.GetAllPageConfig(Key);
    pageList.forEach((items, keyindex) => {
      if (items.Key) {
        if (items.Key.toLowerCase() === Key.toLowerCase()) {
          if (items.Data) {
            allpageConfigweb = items.Data;
            allpageConfigweb = this.PageModalOrPermission(items.Data, Key);
          }
        }
      }
    });
    return allpageConfigweb;
  }

  /**
   * 存储登录信息数据
   * @param obj 需要存储的对象名称
   */
  public SaveStorage(obj: any): void {
    const that = this;
    if (obj) {
      //存储用户信息
      if (obj.Account) {
        obj.Account.IsLogin = true;
        localStorage.setItem("account", JSON.stringify(obj.Account));
      }
      //存取菜单权限
      if (obj.Status.AppMenus) {
        if (obj.Status.AppMenus.length > 0) {
          localStorage.removeItem("menus");
          let arrayMenus = that.GetMenusDataList(obj.Status.AppMenus);
          // localStorage.setItem("menus",JSON.stringify(obj.Account.AppMenus));//存储菜单信息
          localStorage.setItem("menus", JSON.stringify(arrayMenus || []));//存储菜单信息
        }
      }
      //如果后端xml修改后更新本地json文件
      if (obj.Status.AppPageConfig) {
        const pagesData: Array<AppPageConfig> = obj.Status.AppPageConfig.pages || [];//获取修改过的xml文件
        let oldPagesData: Array<AppPageConfig> = that.GetStorageKey("pageconfig") || [];//获取所有xml文件
        // console.log(oldPagesData.length,"获取xml");
        // console.log(pagesData.length,"获取xml2");
        if (pagesData.length > 0) {
          pagesData.forEach((pages, index) => {
            let findIndex = oldPagesData.findIndex(ut => ut.Key.trim().toLowerCase() === pages.Key.trim().toLowerCase());
            if (findIndex >= 0) {
              oldPagesData[findIndex].Data = pages.Data;
            } else {
              oldPagesData.push(pages);//如果新增xml文件则直接添加进去。
            }
          });
          localStorage.setItem("pageconfig", JSON.stringify(oldPagesData));
          //#region  保存缓存文件到手机安装目录中，卸载程序则自动删除 
          if(that.platform.is("cordova")){
            try {
              this.nativeService.WriteFile({ stringContent: JSON.stringify(oldPagesData) }).then(result => {
                console.log(result);
              }).catch(error => {
                console.error(error, "保存缓存文件到手机安装目录中");
              });
            } catch (err) {
              console.error(err, "保存缓存文件到手机安装目录中try");
            }
          }
          //#endregion
        }
        localStorage.setItem("pageConfigTime", obj.Status.AppPageConfig.Stamp || 0);//缓存当前页面时间戳

      }
      //缓存Token
      if (obj.Status.Token) {
        localStorage.setItem("token", JSON.stringify(obj.Status.Token));
        //  this.getOutnumber();
      }

      //模块权限
      if (obj.Status.PageMode) {
        // console.log("PageMode");
        if (Object.keys(obj.Status.PageMode).length > 0) {
          let oldTempPage: any = obj.Status.PageMode;
          if (this.GetStorageKey("pagemode")) {
            let TempPage = this.GetStorageKey("pagemode");
            oldTempPage = Object.assign(oldTempPage, TempPage);
          }
          localStorage.setItem("pagemode", JSON.stringify(oldTempPage));
        }
      }
      //数据权限
      if (obj.Status.PageFieldPermission) {
        if (Object.keys(obj.Status.PageFieldPermission).length > 0) {
          localStorage.setItem("fieldpermission", JSON.stringify(obj.Status.PageFieldPermission));
        }
      }
      //采集点
      if (obj.Status.TempPage) {
        if (Object.keys(obj.Status.TempPage).length > 0) {
          let oldArray: Array<any> = obj.Status.TempPage;
          if (this.GetStorageKey("temppage")) {
            oldArray = this.GetStorageKey("temppage");
            obj.Status.TempPage.forEach((newtempage, index) => {
              let findIndex = oldArray.findIndex(ut => ut.pagename.trim().toLowerCase() === newtempage.pagename.trim().toLowerCase());
              if (findIndex >= 0) {
                oldArray[index] = newtempage;
              } else {
                oldArray.push(newtempage);
              }
            });
          }
          localStorage.setItem("temppage", JSON.stringify(oldArray));
        }
      }
      //判断是否PG是否排班
      if (obj.Status.Info) {
        if (obj.Status.Info.SN) {
          localStorage.setItem("tbstore", JSON.stringify({ "ID": obj.Status.Info.SN.a_FK_Store_ID, "name": obj.Status.Info.SN.c_Name, "address": obj.Status.Info.SN.c_StreetAddress }));
          localStorage.setItem("pginfo", JSON.stringify(obj.Status.Info.SN))
        } else {
          if (obj.Status.Info.InStore) {
            localStorage.setItem("tbstore", JSON.stringify({ "ID": obj.Status.Info.StoreList[0] }));
          }
        }
      }
      /**
       * 返回下班的条件判断
       */
      // debugger;
      if (obj.Status.BtnRemindInfo && obj.Status.BtnRemindInfo.length > 0) {
        localStorage.setItem("btnremindinfo", JSON.stringify(obj.Status.BtnRemindInfo));
      } else {
        // localStorage.removeItem("btnremindinfo");//清空条件判断
      }
    }
  }

  /**
   * 第一次登录时页面配置文件存入全部存入
   * @param data 返回的页面数据格式，并且缓存当前文件的时间戳
   */
  SetAllPageConfig(data: any) {
    if (data) {
      let pages = data.pages || data.Pages;
      let stamp = data.stamp || data.Stamp;
      if (pages.length > 0) {
        localStorage.setItem("pageconfig", JSON.stringify(pages) || null);//缓存所有页面数据
        localStorage.setItem("pageConfigTime", stamp || null);//缓存当前页面时间戳
        if (this.platform.is("cordova")) {
          //#region  保存缓存文件到手机安装目录中，卸载程序则自动删除 
          try {
            this.nativeService.WriteFile({ stringContent: JSON.stringify(pages) }).then(result => {
              console.log(result);
            }).catch(error => {
              console.log(error, "第一次登录时页面配置");
            });
          } catch (err) {
            console.log(err, "第一次登录时页面配置 try");
          }
        }
      }
    }
  }

  /**
   * 获取GUID,app端返回的是数据库对应的guid,例如:'1212f4f6-8d91-4534-a20c-87aed2c3c90f',网页端返回的是时间格式;例如:'201911041211455'
   */
  GUID(): Promise<string> {
    const that = this;
    return new Promise<string>((reject, resolve) => {
      let getNowDate: string = that.getNowDatetime;
      console.log(getNowDate);
      if (that.platform.is("cordova")) {
        if (that.platform.is("android")) {
          try {
            cordova.plugins.camera.GUID("get GUID", function (data) {
              reject(data);
            }, function (err) {
              reject(getNowDate);
            });
          } catch (err) {
            reject(getNowDate);
          }
        } else {
          reject(getNowDate);
        }
      } else {
        reject(getNowDate);
      }
    });
  }
  /**
  * 判断微信是否支持
  */
  get IsWeixinBrowser() {
    var ua = navigator.userAgent.toLowerCase();
    var result = (/micromessenger/.test(ua)) ? true : false;
    if (result) {
      console.log('你正在访问微信浏览器');
    }
    else {
      console.log('你访问的不是微信浏览器');
    }
    return result;
  }
  /**
   * 判断是否来自微信浏览器并且是android；
   */
  get isWeixinAndroid() {
    if (this.IsWeixinBrowser) {
      if (/android/i.test(navigator.userAgent)) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }
  /**
   * 判断是否来自微信浏览器并且是IOS；
   */
  get isWeixinIOS() {
    if (this.IsWeixinBrowser) {
      if (/ipad|iphone|mac/i.test(navigator.userAgent)) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  /**
 * 判断是否是android平台
 */
  get isAndroid(): boolean {
    return this.platform.is("cordova") && this.platform.is("android");
  }

  /**
   * 是否ios真机环境
   * @return {boolean}
   */
  get isIos(): boolean {
    return this.platform.is("cordova") && (this.platform.is('ios') || this.platform.is('ipad') || this.platform.is('iphone'));
  }

  /**
 * 判断当前手机系统版本是否小于5.0
 */
  get Isandroidversion() {
    const that = this;
    let isplatform: boolean = false;
    if (that.platform.is("cordova")) {
      if (that.platform.is("android")) {
        if (that.device.version) {
          // if(that.device.version.toString().startsWith("5")){
          //   isplatform=true;
          // }else 
          if (that.device.version.toString().startsWith("4")) {
            isplatform = true;
          } else if (that.device.version.toString().startsWith("3")) {
            isplatform = true;
          } else if (that.device.version.toString().startsWith("2")) {
            isplatform = true;
          }
        }
      }
    }
    return isplatform;
  }

  /**
 * 获取移动设备系统版本号 例如android:6.0
 */
  get GetVersion(): string {
    return this.device.version;

  }

  /**
   * 获取移动设备的模型或产品名称
   */
  get GetModel(): string {
    return this.device.model || "";
  }
  /**
   * 获取移动设备制造商 例:huawei
   */
  get GetBrand(): string {
    return this.device.manufacturer || "";
  }
  /**
   * 获取移动设备操作系统名称 例:Android,ios,windows;
   */
  get GetSystem(): string {
    return this.device.platform || "";
  }
  /**
   * 获取移动设备序列号
   */
  get GetSerial(): string {
    return this.device.serial || "";
  }
  /**
   * 获取移动设备通用唯一标识uuid，例如：‘78ca1fe2c1d3b584’
   */
  get GetUUid(): string {
    return this.device.uuid || "";
  }
  /**
   * 是否真机环境,Android/ios(不包含移动端浏览器)
   * @return {boolean}
   */
  get isMobile(): boolean {
    return this.platform.is('cordova');
  }
  /**
   * 
   * @param key 
   * @param value 
   */
  SetBrowsHistorystring(key: string, value: string): any {
    const that = this;
    let _temp: Array<any> = that.getSessionStorageInfo(key) || [];
    if (!_temp.find(y => that.decodeBase64(y) == value)) {
      let _value: any = that.encodeBase64(value);
      _temp.push(_value);
      sessionStorage.setItem(key, JSON.stringify(_temp));
    }
  }
  /**
* 浏览轨迹
* @param historyurl 存储当前的记录名称
*/
  setBrowsingHistory(historyurl: string) {
    const that = this;
    that.SetBrowsHistorystring("_imei", historyurl.toLowerCase());
  }
  /**
    * 跳转连接 url,obj不能同时为空
    * @param url 跳转的url名称,例如:https://xxx.xxxxx.com| localhost:8080;
    * @param obj 是否数组,主要针对跳转时带queryParams参数时调用，例如 that.router.navigate(["http://xxx.xxxxxx.com"], {"queryParams":{}});
    */
  Go(url: string = "", obj: any = null) {
    const that = this;
    if (url || obj) {
      that.setBrowsingHistory(url);
      if (url && !obj) {
        that.router.navigateByUrl(url);
      } else {
        let _obj: any = { "queryParams": obj };
        that.router.navigate([url], _obj);
      }
    }
  }
  getSessionStorageInfo(key): any {
    let obj: any = sessionStorage.getItem(key) || null;
    if (obj) {
      return JSON.parse(obj) || null;
    } else {
      return null;
    }
  }

     /**
   * 存储登录信息数据不包含修改ALL.json
   * @param obj 需要存储的对象名称
   */
  SaveStorageWechat(obj:any):void{
    const that =this;
  if(obj){
    //存储用户信息
    if(obj.Account){
      obj.Account.IsLogin=true;
      localStorage.setItem("account",JSON.stringify(obj.Account));
    }
    //存取菜单权限
    if(obj.Status.AppMenus){
      if(obj.Status.AppMenus.length>0){
        localStorage.removeItem("menus");
        let arrayMenus=that.GetMenusDataList(obj.Status.AppMenus);
        // localStorage.setItem("menus",JSON.stringify(obj.Account.AppMenus));//存储菜单信息
        localStorage.setItem("menus",JSON.stringify(arrayMenus||[]));//存储菜单信息
      }
    }
    //缓存Token
    if(obj.Status.Token){
      localStorage.setItem("token",JSON.stringify(obj.Status.Token));
    //  this.getOutnumber();
    }

    //模块权限
    if(obj.Status.PageMode){
      // console.log("PageMode");
      if(Object.keys(obj.Status.PageMode).length>0){
        let oldTempPage:any = obj.Status.PageMode;
        if(this.GetStorageKey("pagemode")){
         let  TempPage=this.GetStorageKey("pagemode");
          oldTempPage = Object.assign(oldTempPage,TempPage);
        }
        localStorage.setItem("pagemode",JSON.stringify(oldTempPage));
      }
    }
    //数据权限
    if(obj.Status.PageFieldPermission){
      if(Object.keys(obj.Status.PageFieldPermission).length>0){
        localStorage.setItem("fieldpermission",JSON.stringify(obj.Status.PageFieldPermission));
      }
    }
    //采集点
    if(obj.Status.TempPage){
      if(Object.keys(obj.Status.TempPage).length>0){
        let oldArray:Array<any> = obj.Status.TempPage;
        if(this.GetStorageKey("temppage")){
           oldArray=this.GetStorageKey("temppage");
          obj.Status.TempPage.forEach((newtempage,index)=>{
            let findIndex=oldArray.findIndex(ut=>ut.pagename.trim().toLowerCase()===newtempage.pagename.trim().toLowerCase());
            if(findIndex>=0){
              oldArray[index]=newtempage;
            }else{
              oldArray.push(newtempage);
            }
          });
        }
        localStorage.setItem("temppage",JSON.stringify(oldArray));
      }
    }
    //判断是否PG是否排班
    if(obj.Status.Info){
      if(obj.Status.Info.SN){
        localStorage.setItem("tbstore",JSON.stringify({"ID":obj.Status.Info.SN.a_FK_Store_ID,"name":obj.Status.Info.SN.c_Name,"address":obj.Status.Info.SN.c_StreetAddress}));
        localStorage.setItem("pginfo",JSON.stringify(obj.Status.Info.SN))
     }else{
        if(obj.Status.Info.InStore){
          localStorage.setItem("tbstore",JSON.stringify({"ID":obj.Status.Info.StoreList[0]}));
        }
     }
    }
    /**
     * 返回下班的条件判断
     */
    // debugger;
    if(obj.Status.BtnRemindInfo && obj.Status.BtnRemindInfo.length>0){
        localStorage.setItem("btnremindinfo",JSON.stringify(obj.Status.BtnRemindInfo));
    }else{
      // localStorage.removeItem("btnremindinfo");//清空条件判断
    }
  }
}

  /**
   * 获取android 手机上唯一识别码；只能适用于android
   */
  GetIMEI() {
    const that = this;
    return new Promise<any>((resolve, reject) => {
      that.file.readAsText(that.file.externalRootDirectory, ".imei").then(data => {
        resolve(data);
      }).catch(err => {
        that.file.writeFile(that.file.externalRootDirectory, ".imei", that.device.uuid, { replace: true }).then(data => {
          resolve(that.device.uuid);
        }).catch(err => {
          reject(err);
        });
      });
    });

  }

  /**
   * 获取当前url所带参数
   */
  GetQueryString(name) {
    let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
    let searchArr = window.location.href.split("?");
    let search = "";
    if(searchArr.length > 1){
        search = searchArr[1];
    }
    var r = search.match(reg);
    if (r != null) return decodeURIComponent(r[2]); return null;
  }

    /**
   * 获取n天之前的时间戳（秒级） 企业微信判断时间戳
   * @param days 
   * @returns 
   */
  getBeforeMonthTimeStamp(days:number = 30){
    let timestamp = new Date().getTime();
    return Math.floor(timestamp/1000-days*24*60*60);
  }

  /**
   * 获取当前位置-android和ios
   * @param element 绑定的html对象
   */
  // public getGDCurrentPosition(element: any): Promise<any> {
  //   const that = this;
  //   return new Promise<PositionOptions>((resolve, reject) => {
  //     that.gd.getCurrentPosition().then((pt: PositionOptions) => {
  //       console.log(pt, "定位成功");
  //       if (pt["status"] == "定位成功") {
  //         resolve(pt);
  //       } else {
  //         reject(pt);
  //       }
  //     }).catch(err => {
  //       console.log(err, "定位失败");
  //       reject(err);
  //     });
  //   });
  // }

 
}
